import { defineStore } from "pinia";
import { useStorage } from "@vueuse/core";

export type FilterValue = string | number | boolean;
export type FilterValueList = Array<FilterValue>;
export type FilterList = Record<string, FilterValueList>;

export type FilterState = {
  [key: string]: FilterList;
};

export const useFilterState = defineStore("filter-state", {
  state: () => {
    return {
      state: useStorage("filter-state", {} as FilterState, sessionStorage),
    };
  },
  actions: {
    update(category: string, model: FilterList): void {
      this.state[category] = { ...model };
    },
  },
});

